//import to reducer from action
import { ATTENDEESMESSAGING_TOTAL_COMMUNICATION,ATTENDEESMESSAGING_TOTAL_MSGENGMNTBARCHART } from "AttendeesmessagingCommunicationAction";

export const AttendeesmessagingTotalCommunication = (state = {}, action) => {
    switch (action.type) {
      case ATTENDEESMESSAGING_TOTAL_COMMUNICATION:
        return action.payload;
        break;
      default:
        return state;
        break;
    }
}

// Local reducer for {Messaging Engagement (Chart view of how attendees communicated over the selected date range)}
export const AttendeesmessagingEngagementChart = (state = {}, action) => {
  switch (action.type) {
    case ATTENDEESMESSAGING_TOTAL_MSGENGMNTBARCHART:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
}